export const staticData = require("./data/product-data.json");
export const AVAILABLE_PROVINCES = ["ON", "NB", "NS", "NF", "BC"];
